import '../styles/fitness-rate-glass.css';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useFitnessRamp} from '../hooks/useFitnessRamp';
import {fitnessProgress, fitnessSparkline} from '../utils/fitnessProgress';
import {NmLoader} from './NmLoader';
import '../styles/home-fitness-ramp.css';

export function HomeFitnessRamp({athleteId, refreshKey}: {athleteId?: number | null; refreshKey?: unknown}) {
  const {t, i18n} = useTranslation();
  const result = useFitnessRamp(athleteId, refreshKey);
  const [help, setHelp] = useState(false);
  const {windows, asOf} = fitnessProgress(result.days, result.today);
  const number = (value: number) => {
    const rounded = Math.round(value);
    return `${rounded > 0 ? '+' : ''}${new Intl.NumberFormat(i18n.language, {maximumFractionDigits: 0}).format(Object.is(rounded, -0) ? 0 : rounded)}`;
  };
  return <div className="home-fitness-ramp" aria-busy={result.loading}>
    <header><span>{t('fitnessProgress.ramp')}</span><button type="button" aria-label={t('fitnessProgress.about')} aria-expanded={help} onClick={() => setHelp(value => !value)}>ⓘ</button></header>
    {help && <p>{t('fitnessProgress.formula')}</p>}
    {result.loading ? <NmLoader label={t('fitnessProgress.loading')} /> : result.error ? <p role="alert">{t('fitnessProgress.error')} <button type="button" onClick={result.retry}>{t('fitnessProgress.retry')}</button></p> : <>
      <div className="home-fitness-ramp__windows">{windows.map(window => <div className="fitness-rate-glass" key={window.days}>
        <span>{t('fitnessProgress.days', {count: new Intl.NumberFormat(i18n.language).format(window.days)})}</span>
        <strong className={window.rate != null && Math.round(window.rate) < 0 ? 'metric-value--negative' : ''}><bdi dir="ltr">{window.rate == null ? '—' : number(window.rate)}</bdi></strong>
        {window.rate != null && <svg viewBox="0 0 120 32" preserveAspectRatio="none" aria-hidden="true"><path className={Math.round(window.rate) < 0 ? 'metric-value--negative' : undefined} d={fitnessSparkline(window.points)} /></svg>}
        {window.rate == null && <span>{t('fitnessProgress.insufficient')}</span>}
      </div>)}</div>
      {asOf && <p>{t('fitnessProgress.asOf', {date: new Intl.DateTimeFormat(i18n.language, {year:'numeric',month:'short',day:'numeric'}).format(new Date(`${asOf}T12:00:00`))})}</p>}
    </>}
  </div>;
}
